import {
  FaTachometerAlt,
  FaUsers,
  FaClipboardList,
  FaBook,
  FaCogs,
  FaChartLine,
  FaClock,
  FaCube,
  FaTrashAlt,
  FaCheck,
  FaRegStar,
  FaRegCopy,
  FaRegObjectGroup,
  FaChevronDown,
  FaRegFilePdf,
} from "react-icons/fa";
import { TfiTime } from "react-icons/tfi";
import {
  FiMessageSquare,
  FiMoreVertical,
  FiMail,
  FiPhone,
  FiCalendar,
  FiClock,
  FiPlusCircle,
  FiEye,
  FiEdit2,
  FiUsers,
  FiUserCheck,
  FiDownload,
  FiLink,
} from "react-icons/fi";
import { BsStarFill, BsPaperclip, BsCopy } from "react-icons/bs";
import { CiCircleMore } from "react-icons/ci";
import { BiMoviePlay } from "react-icons/bi";
import {
  IoFootstepsOutline,
  IoSearch,
  IoReorderThreeSharp,
} from "react-icons/io5";
import { RiDeleteBin6Line, RiDashboardFill } from "react-icons/ri";
import {
  MdOutlineLockPerson,
  MdOutlineOpenInNew,
  MdKeyboardArrowDown,
} from "react-icons/md";
import {
  LuMessageSquareCode,
  LuFileText,
  LuGalleryThumbnails,
  LuFileQuestion,
  LuEarth,
  LuCopy,
  LuNotebookPen,
} from "react-icons/lu";
import { SlCloudUpload } from "react-icons/sl";
import { RxCross2 } from "react-icons/rx";
import {
  AiOutlineEye,
  AiOutlineEyeInvisible,
  AiOutlinePlayCircle,
} from "react-icons/ai";

export const DownArrowIcon = MdKeyboardArrowDown as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const OutlinePlayCircleIcon = AiOutlinePlayCircle as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const OpenInNewIcon = MdOutlineOpenInNew as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const EyeOpenIcon = AiOutlineEye as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const EyeOffIcon = AiOutlineEyeInvisible as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const LuNotebookPenIcon = LuNotebookPen as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;
export const LinkIcon = FiLink as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const CopyIcon = BsCopy as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const CopyIcon2 = LuCopy as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const PaperClipIcon = BsPaperclip as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const PdfIcon = FaRegFilePdf as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const DragIcon = IoReorderThreeSharp as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const BrowserIcon = LuEarth as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const DownloadIcon = FiDownload as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const CloudUpload = SlCloudUpload as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const CrossIcon = RxCross2 as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const ChevronDownIcon = FaChevronDown as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const LockPersonIcon = MdOutlineLockPerson as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const FileQuestionIcon = LuFileQuestion as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const GalleryIcon = LuGalleryThumbnails as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const FileTextIcon = LuFileText as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const MessageSquareCodeIcon = LuMessageSquareCode as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const RegObjectGroupIcon = FaRegObjectGroup as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const DashboardIcon = RiDashboardFill as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const EditIcon = FiEdit2 as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const DeleteIcon = RiDeleteBin6Line as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const SearchIcon = IoSearch as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const EyeIcon = FiEye as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const FootstepsOutlineIcon = IoFootstepsOutline as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const PlusCircleIcon = FiPlusCircle as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const RegCopyIcon = FaRegCopy as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const MoviePlayIcon = BiMoviePlay as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const ClockIcon = FiClock as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const CircleMoreIcon = CiCircleMore as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const RegStarIcon = FaRegStar as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const MailIcon = FiMail as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const PhoneIcon = FiPhone as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const CalendarIcon = FiCalendar as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const StarFillIcon = BsStarFill as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const TrashIcon = FaTrashAlt as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const CheckIcon = FaCheck as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const MoreVerticalIcon = FiMoreVertical as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const MessageSquareIcon = FiMessageSquare as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const FaTachometer = FaTachometerAlt as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const FaUsersIcon = FaUsers as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const UserCheckIcon = FiUserCheck as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const UsersIcon = FiUsers as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const FaClipboard = FaClipboardList as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const FaBookIcon = FaBook as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const FaCogsIcon = FaCogs as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const FaChartLineIcon = FaChartLine as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const FaClockIcon = FaClock as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const FaCubeIcon = FaCube as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;

export const TfiTimeIcon = TfiTime as unknown as React.FC<
  React.SVGProps<SVGSVGElement>
>;
